// src/lib/queryClient.js
import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: 24 * 60 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "rq-cache",
});

export const persistOptions = {
  persister,
  maxAge: 24 * 60 * 60_000,
  buster: process.env.REACT_APP_BUILD_ID || "dev",
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      // Persist only successful queries
      if (query.state.status !== "success") return false;

      return true;
    },
  },
};